'use client';

/**
 * 应用Google翻译DOM补丁函数
 *
 * 该函数通过重写Node.prototype.removeChild和Node.prototype.insertBefore方法，
 * 来修复Google翻译在操作DOM时可能出现的节点父子关系错误问题。
 * 主要解决Google翻译试图从错误的父节点移除子节点或在错误的父节点中插入节点的问题。
 *
 * 已知问题：在德语站M端，/payment 路由下应用优惠券时，必定崩溃。（其他场景偶尔崩溃）
 *
 * @issue https://issues.chromium.org/issues/41407169
 * @issue https://github.com/vercel/next.js/issues/58055
 * @solution https://github.com/vercel/next.js/issues/58055#issuecomment-3133346877
 */
export function applyGoogleTranslateDOMPatch() {
  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;

    Node.prototype.removeChild = function (child) {
      if (child.parentNode !== this) {
        // eslint-disable-next-line no-console
        console.warn(
          'Google Translate attempted to remove a child node from the wrong parent. Skipping.',
          {
            childNode: child?.nodeName,
            expectedParent: this?.nodeName,
            actualParent: child?.parentNode?.nodeName,
          },
        );
        return child;
      }

      // eslint-disable-next-line prefer-rest-params
      return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;

    Node.prototype.insertBefore = function (newNode, referenceNode) {
      if (referenceNode && referenceNode.parentNode !== this) {
        // eslint-disable-next-line no-console
        console.warn(
          'Google Translate attempted to insert before a reference node from the wrong parent. Skipping.',
          {
            newNode: newNode?.nodeName,
            expectedParent: this?.nodeName,
            actualParent: referenceNode?.parentNode?.nodeName,
          },
        );
        return newNode;
      }

      // eslint-disable-next-line prefer-rest-params
      return originalInsertBefore.apply(this, arguments);
    };
  }
}
